import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../../../_hooks/useClientId';
import { useRouteParams } from '../../../hooks/useRouteParams';

export enum GivingStrategy {
  DonationToDAF,
  OutrightGiftsToCharity,
  QualifiedCharitableDonations,
}

export enum KindOfProperty {
  Cash,
  Securities,
}

export enum Donor {
  Principal,
  Spouse,
}

export interface DafYear {
  year: number | null;
  type: number;
}

export interface Data {
  hasPartner: boolean | null;
  principalName: string | null;
  partnerName: string | null;
  principalDob: string | null;
  partnerDob: string | null;
  hasChildren: boolean | null;
  givingStrategy: GivingStrategy | null;
  kindOfProperty: KindOfProperty | null;
  donor: Donor | null;
  donationAmount: number | null;
  donationStartYear: number | null;
  dafDonationStartYear: DafYear | null;
  donationEndYear: number | null;
  dafDonationEndYear: DafYear | null;
  dafGrantAmount: number | null;
  dafGrantStartYear: DafYear | null;
  dafGrantEndYear: DafYear | null;
  charityName: string | null;
  fundAccounts: string[] | null;
  dafAccount: string | null;
  maximizeDonations: boolean | null;
}

export interface DafYearOption {
  label: string;
  value: number | null;
  type: number;
}

interface Options {
  givingStrategyOptions: { label: string; value: GivingStrategy }[];
  kindOfPropertyOptions: { label: string; value: KindOfProperty }[];
  donorOptions: { label: string; value: Donor }[];
  principalQcdYearOptions: number[];
  partnerQcdYearOptions: number[];
  donationYearOptions: number[];
  dafStartYearOptions: DafYearOption[];
  dafEndYearOptions: DafYearOption[];
}

export interface WorkflowDTO {
  data: Data;
  options: Options;
}

interface FetcherParams {
  clientId: number;
  goalId: string | null;
}

const fetchWorkflow = async ({ clientId, goalId }: FetcherParams): Promise<WorkflowDTO> => {
  return authFetch(urlWithParams('/Consumer/CharitableGivingWorkflow', { clientId, goalId }));
};

export const useCharitableGivingQuery = () => {
  const clientId = useClientId();
  const { goalId } = useRouteParams();

  return useQuery(
    queryKeys.workflow(clientId, goalId),

    () => fetchWorkflow({ clientId, goalId }),

    {
      cacheTime: 0,
    },
  );
};
